// The film center picker's options: every supported city with its country (one request, about
// 55 KB). Asked once per visit and shared, and started before step 2 needs it: on integration
// the answer took 2.5 s alone and over 5 s when busy, while the picker showed an empty country
// list (2026-10-31). The list is reference data, so a visit keeps it once it has it.

import { getSubmissionFlowApi } from "../../../shared/api/submission";
import { IBreakdownCityDto } from "../../../shared/api/submission/types";

let cached: IBreakdownCityDto[] | null = null;
let asking: Promise<IBreakdownCityDto[]> | null = null;

// The options, asking for them only when no answer is kept or on its way. A failure isn't
// kept: the next call asks again.
export const loadCityOptions = (): Promise<IBreakdownCityDto[]> => {
  if (cached) return Promise.resolve(cached);
  if (asking) return asking;
  const current = getSubmissionFlowApi()
    .getCityOptions()
    .then((options) => {
      if (options && options.length) cached = options;
      return options;
    });
  asking = current;
  const done = () => {
    if (asking === current) asking = null;
  };
  current.then(done, done);
  return current;
};

// Started ahead (the email code screen): nothing waits on it, a failure is asked again later.
export const preloadCityOptions = () => {
  loadCityOptions().catch(() => undefined);
};

// What a page can show at once, before any request answers.
export const keptCityOptions = (): IBreakdownCityDto[] => cached || [];

// Test seam.
export const forgetCityOptionsForTests = () => {
  cached = null;
  asking = null;
};
